import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { useApiCall } from '../../api/apiCallHook';
import { submitFeedback } from '../../api';
import { Row, Col, Alert, Select, Radio } from 'antd';
import Loading from '../../components/Loading';

const { Option } = Select;

const FeedbackForm = () => {
    const { handleSubmit, register, errors, control } = useForm({
        defaultValues: {
            isSatisfy: 'Yes',
        },
    });
    const onSubmit = (value) => {
        value.isSatisfy = value.isSatisfy === 'Yes' ? true : false;
        execute({ request: value });
    };

    const { execute, pending, value, error } = useApiCall(submitFeedback, false);

    return (
        <form className="solutionForBusinessFormContainer" onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <label> Topic</label>
                    <Controller
                        name="topic"
                        as={
                            <Select className="yf-select" style={{ width: '100%' }} placeholder="Select Topic">
                                {topics.map((item) => {
                                    return (
                                        <Option value={item.value} key={item.id}>
                                            {item.label}
                                        </Option>
                                    );
                                })}
                            </Select>
                        }
                        control={control}
                        onChange={([selected]) => {
                            return selected;
                        }}
                        rules={{ required: true }}
                    />
                    <div className="form-error">
                        {/* {errors.name && <span>Name Required</span>}
                         */}
                        {errors.topic && (
                            // <Alert type="error" showIcon message="Topic Required" />
                            <span className="formFieldError">Please enter topic.</span>
                        )}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <span className="paragraph">
                        Are you satisfied with your overall experience with Yoma Fleet Limited?
                    </span>
                    <br />
                    <br />
                    <Controller
                        name="isSatisfy"
                        as={
                            <Radio.Group>
                                <Radio id="feed_back_form_yes" value="Yes">
                                    Yes
                                </Radio>
                                <Radio id="feed_back_form_no" value="No">
                                    No
                                </Radio>
                            </Radio.Group>
                        }
                        control={control}
                        onChange={([event]) => {
                            return event.target.value;
                        }}
                        rules={{ required: true }}
                    />
                    {errors.isSatisfy?.type === 'required' && (
                        <span className="formFieldError">Please select your experience</span>
                    )}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFTextArea
                        test_id="feed_back_form_message"
                        name="message"
                        type="text"
                        row="10"
                        label="Your Message"
                        placeholder="Enter Message"
                        register={register({
                            required: true,
                        })}
                    />
                    {/* <div className="form-error"> */}
                    {errors.message?.type === 'required' && (
                        // <Alert type="error" showIcon message="Email Required" />
                        <span className="formFieldError">Please enter your message.</span>
                    )}
                    {/* </div> */}
                </Col>
            </Row>

            <div>
                <label>
                    Please do not enter any credit card, payment or any other personally identifiable information. If
                    further information is required, we will contact you directly.
                </label>
            </div>
            <br />
            <br />
            <h3>Contact information</h3>
            <br />
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="feed_back_form_name"
                        name="name"
                        type="text"
                        label="Full Name"
                        placeholder="Enter full name"
                        register={register({ required: true })}
                    />
                    {errors.name && (
                        // <Alert type="error" showIcon message="Subject Required" />
                        <span className="formFieldError">Please enter your name.</span>
                    )}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="feed_back_form_email"
                        name="email"
                        type="email"
                        label="Email"
                        placeholder="Enter Email"
                        register={register({
                            required: true,
                            pattern:
                                /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        })}
                    />
                    {/* <div className="form-error"> */}
                    {errors.email?.type === 'required' && (
                        // <Alert type="error" showIcon message="Email Required" />
                        <span className="formFieldError">Please enter email address.</span>
                    )}
                    {errors.email?.type === 'pattern' && (
                        // <Alert type="error" showIcon message="Invalid email format." />
                        <span className="formFieldError">Invalid email format.</span>
                    )}
                    {/* </div> */}
                </Col>
            </Row>

            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="feed_back_form_phone"
                        name="phone"
                        type="text"
                        label="Phone No."
                        placeholder="Enter Phone No."
                        register={register({
                            required: true,
                            minLength: {
                                value: 5,
                                message: 'Phone number length must be 5 digit.',
                            },
                            maxLength: {
                                value: 13,
                            },
                        })}
                    />
                    {/* <div className="form-error"> */}
                    {errors.phone?.type === 'required' && (
                        // <Alert type="error" showIcon message="Email Required" />
                        <span className="formFieldError">Please enter phone number.</span>
                    )}
                    {/* </div> */}
                </Col>
            </Row>

            <div>
                {value !== null && <Alert type="success" message={value.message} />}
                {error !== null && <Alert type="error" message={error.response.data.errors?.email[0]} />}
                {pending ? <Loading /> : <input test_id="feed_back_form_submit" type="submit" label="Submit" />}
                {/* <input type="submit" label="Submit" /> */}
            </div>
        </form>
    );
};
const topics = [
    {
        label: 'Overall experience',
        value: 'Overall experience',
    },
    {
        label: 'Payment Related Feedback',
        value: 'Payment Related Feedback',
    },
    {
        label: 'Application Related Feedback',
        value: 'Application Related Feedback',
    },
    {
        label: 'Customer Service Feedback',
        value: 'Customer Service Feedback',
    },
    {
        label: 'Others',
        value: 'Others',
    },
];
export default FeedbackForm;
